<template>
	<div id="dorm_left1">
		<div class="cc-header">
			<div class="title_circle"></div>
			学生签到分析
		</div>
		<dv-scroll-board :config="config" class="table" />
	</div>
</template>
<script>
import { sendWebsocket, closeWebsocket } from '@/common/websocket.js';
import { sendWebsocket1, closeWebsocket1 } from '@/common/websocket1.js';
import { sendWebsocket2, closeWebsocket2 } from '@/common/websocket2.js';
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
export default {
	data() {
		return {
			config: {}
		};
	},
	mounted() {
		this.initData();
		this.requstWs();
	},
	beforeDestroy() {
		closeWebsocket();
		closeWebsocket1();
		closeWebsocket2();
	},
	methods: {
		wsMessage(data) {
			console.log(data);
			if (data.indexOf('refresh_page') != -1) {
				window.location.reload();
				window.AndroidWebView.refresh();
			} else if (data.indexOf('upgrade_3_' + orgId) != -1) {
				this.$http.get("api/client/new/getUpdateUrl?orgId=" + orgId + "&type=3").then(res => {
					if (res.data.code === 200) {
						console.log(res.data.url);
						window.AndroidWebView.updateApp(res.data.url);
					}
				})
			} else if(data.indexOf('refresh_dormAccess_'+orgId) != -1){
				this.initData();
			}
		},
		wsError() {
		},
		requstWs() {
			//window.location.host
			if (window.location.protocol == 'http:') {
				sendWebsocket2('ws://' + window.location.host + '/otessWd/wsPush.action?objId=upgrade_3_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket1('ws://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_page&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket('ws://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_dormAccess_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
			} else {
				sendWebsocket2('wss://' + window.location.host + '/otessWd/wsPush.action?objId=upgrade_3_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket1('wss://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_page&objType=data', {}, this.wsMessage, this.wsError)
				sendWebsocket('wss://' + window.location.host + '/otessWd/wsPush.action?objId=refresh_dormAccess_' + orgId + '&objType=data', {}, this.wsMessage, this.wsError)
			}
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/dorm/accessRecord?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					var result = [];
					var cosType = res.data.cosType;
					var cosPath = res.data.cosPath;
					for (let i = 0; i < res.data.result.length; i++) {
						var record = res.data.result[i];
						if (record.accessImage != undefined && record.studentName != undefined && record.dormName != undefined) {
							if (cosType == '0') {
								if (record.accessType == '1') {
									result.push(['<div class="main-value qd_con"><div class="qd_head float-l"><img width="100%" height="100%" src="' + cosPath + record.accessImage + '"></div><div class="qd_info float-l"><ul><li><img width="100%" height="100%" src="' + require("../../assets/img/head_icon.png") + '">' + record.studentName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/dorm_icon.png") + '">' + record.dormName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/time_icon.png") + '">' + record.accessTime + '</li></ul></div><div class="status_txt green">&#8226; 进</div></div>']);
								} else {
									result.push(['<div class="main-value qd_con"><div class="qd_head float-l"><img width="100%" height="100%" src="' + cosPath + record.accessImage + '"></div><div class="qd_info float-l"><ul><li><img width="100%" height="100%" src="' + require("../../assets/img/head_icon.png") + '">' + record.studentName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/dorm_icon.png") + '">' + record.dormName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/time_icon.png") + '">' + record.accessTime + '</li></ul></div><div class="status_txt yellow">&#8226; 出</div></div>']);
								}
							} else {
								if (record.accessType == '1') {
									result.push(['<div class="main-value qd_con"><div class="qd_head float-l"><img width="100%" height="100%" src="' + this.$baseURL + record.accessImage + '"></div><div class="qd_info float-l"><ul><li><img width="100%" height="100%" src="' + require("../../assets/img/head_icon.png") + '">' + record.studentName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/dorm_icon.png") + '">' + record.dormName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/time_icon.png") + '">' + record.accessTime + '</li></ul></div><div class="status_txt green">&#8226; 进</div></div>']);
								} else {
									result.push(['<div class="main-value qd_con"><div class="qd_head float-l"><img width="100%" height="100%" src="' + this.$baseURL + record.accessImage + '"></div><div class="qd_info float-l"><ul><li><img width="100%" height="100%" src="' + require("../../assets/img/head_icon.png") + '">' + record.studentName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/dorm_icon.png") + '">' + record.dormName + '</li><li><img width="100%" height="100%" src="' + require("../../assets/img/time_icon.png") + '">' + record.accessTime + '</li></ul></div><div class="status_txt yellow">&#8226; 出</div></div>']);
								}
							}
						}
					}
					var config = {
						data: result,
						oddRowBGC: 'none',
						evenRowBGC: 'none',
						rowNum: 5, //表格行数
						waitTime: 200000
					};
					_this.config = config;
				}
			});
		}
	}
};
</script>

<style lang="scss">
#dorm_left1 {
	height: 100%;

	.qd_con {
		width: 96%;
		padding: 5%;
		height: 2rem !important;
		overflow: hidden;
		margin-top: 0.2rem;
		position: relative;
	}

	.qd_head {
		width: 1rem;
		height: 1.4rem;
	}

	.qd_info {
		margin-left: 0.12rem;
	}

	.qd_info li {
		font-size: 0.25rem;
		margin-top: 0.2rem;
		line-height: 0.22rem;
		overflow: hidden;
		width: 3.5rem;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.qd_info li img {
		width: 0.2rem;
		margin-right: 0.05rem;
	}

	.qd_info li:nth-child(1) {
		color: #00f0ff;
	}

	.status_txt {
		position: absolute;
		bottom: 0.25rem;
		right: 0.3rem;
		font-size: 0.2rem;
		font-weight: bold;
		line-height: 0.2rem;
	}


	.qd_con .table {
		width: 100%;
		height: 100%;
	}

	.ceil {
		padding: 0;
	}

	.rows {
		height: 84vh !important;
	}

	.dv-scroll-board .row-item {
		max-height: 2.27rem !important;
		line-height: 2rem !important;
	}
}
</style>
